/* Entry point. Mounts the app and nothing else. */

import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './app/providers.js';
import { buildRouter } from './app/router.js';
import { runtimeConfig, startErrorTracking } from './observability/sentry.js';
import './styles/index.css';

/* Before anything else, so a failure while mounting is still reported. Does
 * nothing at all without a DSN, which is the case in development and in any
 * environment where one has not been configured. */
const config = runtimeConfig();
startErrorTracking({
  dsn: config.sentryDsn,
  /* The server does not tell the browser which environment it is, and it does
   * not need to: the DSNs differ per environment, so the project an event lands
   * in already says. `import.meta.env.MODE` is the build's own view and is the
   * honest answer to what this bundle is. */
  environment: import.meta.env.MODE,
  release: config.release ?? 'unknown',
});

const container = document.getElementById('root');
if (!container) throw new Error('No #root element. index.html is wrong.');

const router = buildRouter();

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
